import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetBonusesPersonal = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_PERSONAL_LIST_BONUSES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetBonusesPersonalAction(data.data));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetBonusesPersonal as SetGetBonusesPersonal
}